import { connect } from 'react-redux';
import AutoRedeemPromoCode from './auto_redeem_promo_code';
import { setApplicationError } from '../../actions/aplication_error';
import { clearPromoCode } from '../../actions/application';

const mapStateToProps = ({ user }) => ({
  userId: user?.user?.id
});

const mapDispatchToProps = {
  setApplicationError,
  clearPromoCode
};

export default connect(mapStateToProps, mapDispatchToProps)(AutoRedeemPromoCode);
